const initialState = {
  message: null,
  show: false,
  notificationType: null
};

export function notification(state = initialState, action) {
  switch (action.type) {
    case "SHOW_NOTIFICATION":
      return {
        show: true,
        notificationType: action.notificationType,
        message: action.message
      };
    case "HIDE_NOTIFICATION":
      return { ...state, show: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notification.js